import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const cigConfig: RouterStateConfig = {
    cig: {
        parent: "track",
        configId: "CigReportGenerator",
        url: "/tools/cig",
        component: (): any => {
            return null;
        },
        data: {
            menuKbItems: null as any,
        },
        pageId: {
            section: "cig",
        },
        trackingId: {
            section: "cig",
            subSection: "home",
        },
        pageTitle: null as any,
    },
};
